import React, { useState, useEffect, Fragment, useMemo } from 'react'
import { Highlighter } from 'react-bootstrap-typeahead'
import TypeaheadInput from 'components/TypeaheadInput'
import './style.scss'

const SelectServiceDefinition = props => {
  const [state, setState] = useState(() => {
    return {
      ...props
    }
  })

  const sortedOptions = useMemo(() => {
    return state.options.slice().sort((a, b) => a.label.localeCompare(b.label))
  }, [state.options])

  const onChange = value => {
    const selected = state.options.find(item => item.value === value)

    setState(() => ({ ...props, selected: selected }))
    dispatchData(selected)
  }

  const dispatchData = value => {
    var customEvent = new CustomEvent('typeahead-select:change', {
      detail: value
    })
    window.dispatchEvent(customEvent)
  }

  const renderMenuItemChildren = (option, props) => {
    return (
      <Fragment>
        <div className='d-flex'>
          <span className='me-3 my-auto code'>
            <Highlighter search={props.text}>{option.hcpcs}</Highlighter>
          </span>
          <span className='me-3 my-auto'>
            <Highlighter search={props.text}>{option.label}</Highlighter>
          </span>
          <div className='my-auto ms-auto'>
            <span className='text-grey'>{option.amount}</span>
          </div>
        </div>
      </Fragment>
    )
  }

  return (
    <>
      <div
        className={`input required  select-service-definition ${state.errors ? 'error' : null} `}
        id='service_definition_id_input'
      >
        <label className={`label mb-2`}>
          Which service? <abbr title='required'>*</abbr>
        </label>
        <br />
        <div className='org-typeahead'>
          <TypeaheadInput
            {...state}
            filterBy={['hcpcs', 'full_name']}
            options = {sortedOptions}
            onChange={onChange}
            renderMenuItemChildren={renderMenuItemChildren}
          />
        </div>
      </div>
    </>
  )
}

export default SelectServiceDefinition
